import React from 'react';

import { flagStyles } from '../settings';

const SvgDE = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1320px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgDE;
